import { gql } from "@apollo/client";
import useWrappedQuery from "../../common/data-fetching/useWrappedQuery.js";

const QUERY_SCOPE = "insight";
const QUERY_NAME = "insightMostImportantResponsibilities";

export const QUERY = gql`
  query ${QUERY_NAME}_${QUERY_SCOPE}(
    $queryText: String
    $limit: Int
    $language: String
  ) {
    ${QUERY_SCOPE} {
        _id
        ${QUERY_NAME} (
        queryText: $queryText
        limit: $limit
        language:$language

      ) {
        firstValue
        totalCount
      }
    }
  }
`;

export default function useQueryInsightMostImportantResponsibilities(
  queryText,
  limit,
  language
) {
  const variables = { queryText, limit, language };

  return useWrappedQuery(QUERY, QUERY_SCOPE, QUERY_NAME, {
    variables,
  });
}
